// Azure migration: import from Azure-configured files
import { domain, stage, featureFlags } from './config-current';

export const Stage = stage;
export const FeatureFlags = featureFlags;
export const ApiGateway = {
  domain,
  formulaNutrition: `${domain}/formula-nutritions`,
  dispensingHardwareType: `${domain}/dispensing-hardware-types`,
  documentGeneration: `${domain}/document-generation`,
  employee: `${domain}/employees`,
  pdfService: `${domain}/pdf-service`,
  auth: '' // Update this if you have a dedicated Azure auth endpoint
};